/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImIteResult } from '../models/ImIteResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ImIteResultsService {
    /**
     * Get all IM-ITE results
     * @returns ImIteResult successful
     * @throws ApiError
     */
    public static getAllImIteResults(): CancelablePromise<Array<ImIteResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/im_ite_results.json',
        });
    }
    /**
     * Find IM-ITE results
     * @param requestBody
     * @returns any successful
     * @throws ApiError
     */
    public static findImIteResults(
        requestBody?: {
            testTakerId: string;
            programNumber: string;
            birthYear: number;
            birthMonth: number;
            birthDay: number;
        },
    ): CancelablePromise<{
        status: 'match' | 'no match';
        results: Array<{
            testYear: number;
            testTakerName: string;
            testTakerId: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/im_ite_results/find_results.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Link IM-ITE result
     * @param requestBody
     * @returns ImIteResult successful
     * @throws ApiError
     */
    public static linkImIteResults(
        requestBody?: {
            testTakerId: string;
            programNumber: string;
            birthYear: number;
            birthMonth: number;
            birthDay: number;
        },
    ): CancelablePromise<Array<ImIteResult>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/im_ite_results/link_result.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
